import { BaseLoginContainerComponent } from '../../../../../coverpath-common/angular/components/login-container/base-login-container.component';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { LoginService } from '../../services/login/login.service';

@Component({
  moduleId: module.id,
  selector: 'login-container',
  templateUrl: './login-container.component.html',
})
export class LoginContainerComponent extends BaseLoginContainerComponent implements OnInit {
  showTFAComponent: boolean = false;

  constructor(
    private amorphicServiceInj: AmorphicService,
    private loginServiceInj: LoginService,
    private routerInj: Router,
    private routeInj: ActivatedRoute
  ) {
    super(amorphicServiceInj, loginServiceInj, routerInj, routeInj);
  }

  onTFAComponentClose(continueRegister?: boolean): void {
    this.continueRegister = continueRegister;
    this.showTFAComponent = false;
  }

  triggerTFAComponent(): void {
    this.showTFAComponent = true;
  }
}
